import { IconService } from './../../../services/icon.service';
import { AttachmentService } from 'src/app/services/attachment.service';
import { AuthService } from './../../../services/auth.service';
import { AddCustomerFavoriteReservationParam } from '../../../models/CustomerFavourite/AddCustomerFavoriteReservationParam';
import { FilterComponent } from './../../booking/filter/filter.component';
import { LoadingService } from './../../../services/loading.service';
import { SelectedVehicleService } from 'src/app/services/selectedVehicle.service'
import { BookingService } from './../../../services/booking.service';
import { ReviewsModalBodyComponent } from './../reviews-modal-body/reviews-modal-body.component';
import { Branch } from './../../../models/Branch';
import { SearchService } from './../../../services/search.service';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnDestroy } from '@angular/core';
import { faArrowLeft, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
import { faHeart } from '@fortawesome/free-regular-svg-icons';
import { faSort } from '@fortawesome/free-solid-svg-icons';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { VehicleReservationSearchParm } from 'src/app/models/VehicleReservationSearchParm';
import { ActivatedRoute, Router } from '@angular/router';
import { Vehicle } from 'src/app/models/Vehicle';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ImageService } from 'src/app/services/image.service';

import { NotificationsService, NotificationType } from 'angular2-notifications';
import { FormBuilder, FormGroup } from '@angular/forms';
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';
import { PolicyType } from 'src/app/models/enums/BookingEnums';
import { Customer } from 'src/app/models/Customer';
import { VehicleReservationSearchSortEnum } from 'src/app/models/enums/General/VehicleReservationSearchSortEnum'
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
import { ApiControllerActionEnum } from 'src/app/models/enums/ApiControllerActionEnum';
import { environment } from 'src/environments/environment';
import { NgwWowService } from 'ngx-wow';
import { Subscription } from 'rxjs';
import { DateFormatPipe } from 'src/app/common/pipes/DateFormatPipe';
import { DropUpLocaionModel } from 'src/app/models/DropUpLocaionModel';
import { LoaderSectionIDsEnum } from 'src/app/models/enums/General/LoaderSectionIDsEnum';
import { RentalServiceDeliveryChannel } from 'src/app/models/enums/Payments/PaymnetsEnum';


declare const showandclose: any;

@Component({
  selector: 'search-vehicle-page',
  templateUrl: './search-vehicle-page.component.html',
  styleUrls: ['./search-vehicle-page.component.css']
})



export class SearchVehiclePageComponent implements OnInit, OnDestroy {



  @Input() selected: boolean;
  @Output() selectedChange = new EventEmitter<boolean>();
  //@Input() searchModel: VehicleReservationSearchParm;
  searchModel: VehicleReservationSearchParm;
  faBriefcase = faBriefcase;

  faGasPump = faGasPump;
  faUser = faUser;
  faMapMarkerAlt = faMapMarkerAlt;
  faCar = faCar;
  faArrowLeft = faArrowLeft
  faKey = faKey;
  faTags = faTags;
  faHeart = faHeart;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faSort = faSort;
  vehicles: Vehicle[];
  branches;
  currency;
  duration;
  promotions;
  page = 1;
  pageSize;
  openInfoWindow: string;



  //searchModel: VehicleReservationSearchParm;
  form: FormGroup;
  searchAvailableVehicleFilterType;
  MakeModelYearSearch: boolean = false;
  vehicleSearch: boolean = false;
  classSearch: boolean = false;
  searchType: VehicleSearchTypeEnum;
  customer: Customer;


  subscriptions: Subscription[] = [];
  selectedDropOffLocation: DropUpLocaionModel;
  totalCount: number=0;
  resultMsg: any;
  advanceForm: any;

  constructor(
    private authService: AuthService,
    private loadingService: LoadingService,
    private selectedVehicleService: SelectedVehicleService,
    private searchService: SearchService, private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer, private route: ActivatedRoute,
    private dialog: MatDialog, private imageService: ImageService,
    private _notifications: NotificationsService, private _fb: FormBuilder,
    private bookingService: BookingService, private router: Router,
    private attachmentService: AttachmentService,
    private iconService: IconService,
    private matDialog: MatDialog,
    private wowService: NgwWowService,
    private _dateFormatPipe: DateFormatPipe,

  ) {

    this.wowService.init();


    // this.vehicles = searchService.getVehicles().sort((low, high) => low.vehiclePrice - high.vehiclePrice);
    this.currency = searchService.getCurrency();
    //this.vehicles = searchService.getVehicles()

    this.matIconRegistry.addSvgIcon(
      "noAvailableRental",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.noAvailableRental)
    );
    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.form = this._fb.group({
      timeOut: 5000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      animate: 'fromRight'
    });


  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(item => {
      item.unsubscribe();
    })
  }

  ngOnInit() {

    this.subscriptions.push(this.searchService.searchModel.subscribe(res => {
      this.searchModel = res;

    }));
    this.pageSize = this.searchService.pageSize;



    //this.service.loadByPage(this.page, this.pageSize);
    this.subscriptions.push(this.searchService.currentOpenInfoWindow.subscribe(res => this.openInfoWindow = res));

    //Subescribe to vehicles list.
    this.subscriptions.push(this.searchService.vehicles.subscribe(res => {

      this.vehicles = res;

    }));
    this.subscriptions.push(this.authService.loggedInCustomer.subscribe(res => {
      if (res != null) {
        this.customer = res;
        this.searchModel.CustomerID=this.customer.customerID;
      }
    }))
    /*  const searchModelJson = this.route.snapshot.paramMap.get('search');
     this.searchModel = JSON.parse(searchModelJson); */

     this.subscriptions.push(this.searchService.branches.subscribe(res => {
       if(res==null&&this.branches==null){
         this.searchService.VehicleReservationSearch(this.searchModel).subscribe(res =>{
           this.branches=res;
           this.searchService.levelZeroTotalCount=res.totalCount;
           var branchList = this.searchService.vehicleReservationResultToBranch(res.lstVehicleReservationSearchResultModel);
           //Update the Branch Store by load the new branch list
           this.searchService.loadBranchList(branchList);


         }, err => {
         })
       }
      this.branches = res;

     }));
    this.subscriptions.push(this.searchService.vehicleReservationSearchAgency.subscribe(res => {

      this.vehicles = null;
      if (res != null) {
        this.totalCount = res.totalCount;
        this.searchAvailableVehicleFilterType = res.searchAvailableVehicleFilterType;
        this.searchType = res.searchAvailableVehicleFilterType;
        switch (res.searchAvailableVehicleFilterType) {
          case VehicleSearchTypeEnum.classSearch:
            this.classSearch = true;
            break;
          case VehicleSearchTypeEnum.MakeModelYearSearch:
            this.MakeModelYearSearch = true;
            break;
          case VehicleSearchTypeEnum.vehicleSearch:
            this.vehicleSearch = true;
            break;
          default:
            this.vehicleSearch = true;
            break
        }
        //Clear previous value
        this.resultMsg=null;
        this.resultMsg=res.msg;


        var vehiclesList = [];
        if (res.result != null) {


          res.result.forEach(element => {
            vehiclesList.push(new Vehicle(element, res.searchAvailableVehicleFilterType));

          });
        }

        //

        this.searchService.loadVehicleList(vehiclesList);
      }

      // this.loadingService.updateLoadingState(false);
    }))


    this.subscriptions.push(this.searchService.selectedDropOffLocation.subscribe(res => {
      this.selectedDropOffLocation = res;
    }));
  }

  get vehicleReservationSearchSortEnum() {
    return VehicleReservationSearchSortEnum;
  }
  get vehicleSearchTypeEnum() {
    return VehicleSearchTypeEnum;
  }
  get ApiControllerActionEnum() {
    return ApiControllerActionEnum;
  }
  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }
  get policyType(): typeof PolicyType {
    return PolicyType;
  }
  mouseover(branch: Branch) {
    branch.icon = "assets/img/pin-blue.svg";
    this.searchService.update(branch);
  }
  mouseout(branch: Branch) {
    branch.icon = "assets/img/pin-grey.svg";
    this.searchService.update(branch);
  }

  onClick() {
    showandclose();
  }

  openFilter() {
    // const dialogConfig = new MatDialogConfig();
    // this.dialog.open(FilterComponent, { panelClass: 'filter-modal' });
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      searchType: this.searchType,
      advanceForm:this.advanceForm
    }
    dialogConfig.panelClass = ['modal-dialog-slideout', 'wow', 'slideInRight'];
    const dialogRef = this.dialog.open(FilterComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {

        if (data != null && data.form) {
         this.advanceForm=data.form;
        }
        if (data != null && data.cancel) {
          this.resetSearch();
         }
      }
    );
  }



  public toggleFavorite(vehicle: Vehicle) {


    let _isFavoriteState = vehicle.isFavorite;

    //IF the Current State is false and toggled to be true
    //(Add it to favo)
    if (!_isFavoriteState) {
      let model = this.getAddToFavoriteRequest(vehicle);


      this.searchService.addCustomerFavouriteReservation(model).subscribe(res => {

        //check if vehicle successfully added to Favorite
        //Then toggle the icon and change the state
        if (res != null) {
          vehicle.isFavorite = !vehicle.isFavorite;
          vehicle.customerFavouriteReservationID = res.toString();
        }

      });
    }
    else {
      if (vehicle.customerFavouriteReservationID != null) {
        this.searchService.deleteCustomerFavouriteReservation(vehicle.customerFavouriteReservationID, this.customer.defaultName).subscribe(res => {

          vehicle.isFavorite = !vehicle.isFavorite;
          vehicle.customerFavouriteReservationID = null;
        });
      }
    }
    this.selected = !this.selected;
    this.selectedChange.emit(this.selected);
  }

  onScroll() {
    /* this.page++;

    this.searchService.loadByPage(this.page, this.pageSize); */
    this.page++;



    if (this.page <= Math.ceil(this.totalCount / this.pageSize))
    {
      this.searchModel.PageNumber = this.page;
      this.searchModel.PageSize = this.pageSize;
      this.subscriptions.push(this.searchService.VehicleReservationSearchByAgency(this.searchModel)
        .subscribe(res => {

          if (res != null) {
            
            


            var vehiclesList = this.vehicles;
            
            if (res.result != null) {
   

              res.result.forEach(element => {
                vehiclesList.push(new Vehicle(element, res.searchAvailableVehicleFilterType));

              });
            }

            //

            this.searchService.loadVehicleList(vehiclesList);
          }


        }));



    }

  }

  resetSearch(){
    this.searchModel.PageNumber = 1;
    this.searchService.VehicleReservationSearchByAgency(this.searchModel).subscribe(res => {
      this.searchService.updateVehicleReservationSearchAgency(res);
      
      })
  }



  sortBy(sortingBy) {

    switch (sortingBy) {
      case VehicleReservationSearchSortEnum.RentalScore:
        {

          this.sortSearchResult(sortingBy);
          break;
        }
      case VehicleReservationSearchSortEnum.Price:
        {
          this.sortSearchResult(sortingBy);
          break;
        }
      case VehicleReservationSearchSortEnum.Odometer:
        {
          this.sortSearchResult(sortingBy);
          break;
        }
    }
    // return this.vehicles;

  }

  sortSearchResult(vehicleReservationSearchSortEnum) {

    this.page=1;
    this.searchModel.PageNumber=1;
    this.searchModel['VehicleReservationSearchSortID'] = vehicleReservationSearchSortEnum;
    this.searchService.VehicleReservationSearchByAgency(this.searchModel).subscribe(res => {
    this.searchService.updateVehicleReservationSearchAgency(res);
    })
  }

  openReviewDialog(vehicle) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: vehicle
    }
    this.dialog.open(ReviewsModalBodyComponent, dialogConfig);
  }
  onVehicleImageClicked(vehicle: Vehicle) {

    vehicle.isImageClicked = true;
    this.imageService.updateVehicleImage(vehicle);
  }
  backToSearch() {

    delete this.searchModel.AgencyID;

    this.searchService.updateSearchModel(this.searchModel);
  }

  onBookNowClicked(vehicle) {

    //Append searchAvailableVehicleFilterType to vehicle to cached it and when refresh get the value
    vehicle.searchAvailableVehicleFilterType = this.searchAvailableVehicleFilterType;

    //this.bookingService.updateVehicle(vehicle);
    //this.bookingService.cachedVehicle(vehicle);
    this.bookingService.vehicleShared = vehicle;
    this.selectedVehicleService.updateVehicle(vehicle);
    this.searchModel.DropOffLocationTypeID = this.selectedDropOffLocation.agencyReturnLocationTypeID;
    this.searchModel.DropOffLocationID = this.selectedDropOffLocation.returnAgencyID;
    this.searchModel.isFromFavorite=false;
    this.searchService.updateSearchModel(this.searchModel);
    this.bookingService.updateSearchModel(this.searchModel);
    //this.bookingService.searchModelShared = this.searchModel;
    this.bookingService.searchAvailableVehicleFilterType = this.searchAvailableVehicleFilterType;
    this.bookingService.deleteCachedReservationSaveAndConfirm();
    this.bookingService.deleteCachedBookingCaseID();
    this.router.navigate(['/booking']);
  }

  getVehicleImage(vehciel: Vehicle) {


    if (vehciel.vehicleImage == null) {

      this.attachmentService.imageHandler(null, AttachmentScopesEnum.Vehicle, AttachmentTypeEnum.VehicleImage).subscribe(res => {
        vehciel.vehicleImage = res + '';//['result']
        // return vehciel.vehicleImage;
      })
    }

    return vehciel.vehicleImage;

  }
  getVehicleImageClass(vehciel: Vehicle) {

    if (vehciel.vehicleImage == null) {

      this.attachmentService.imageHandler(vehciel.classID, AttachmentScopesEnum.Vehicle, AttachmentTypeEnum.VehicleClassImg).subscribe(res => {
        vehciel.vehicleImage = res + '';//['result']
        // return vehciel.vehicleImage;
      })
    }

    return vehciel.vehicleImage;
  }
  getImageLink(scopeId, typeId) {

    return environment.apiUrl + ApiControllerActionEnum.ImageHandler + `?scopeId=${scopeId}&typeId=${typeId}`;
  }
  //#region  Helper
  private getAddToFavoriteRequest(vehicle) {

    let model: AddCustomerFavoriteReservationParam = {
      classID: vehicle.classID,
      makeID: vehicle.makeID,
      modelID: vehicle.modelID,
      year: vehicle.year,
      vehicleID: vehicle.vehicleID,
      plateNumber: vehicle.plateNumber,
      dropOffLocationID: this.searchModel.DropUpLocationAgencyId,
      pickupLocationID: this.searchModel.AgencyID,
      customerID: this.customer.customerID,
      customerName: this.customer.defaultName,
      startDate: this.searchModel.StartDate,
      startDateString: this.searchModel.StartDateString,
      startTimeString: this.searchModel.StartTimeString,
      endDateString: this.searchModel.EndDateString,
      endDate: this.searchModel.EndDate,
      endTimeString: this.searchModel.EndTimeString,
      rateTypeID: vehicle.rateTypeID,
      dropOffLocationTypeID:vehicle.dropOffLocationTypeID,
      fromAgencyName:vehicle.fromAgencyName==null?vehicle.agencyName:vehicle.fromAgencyName,
      rentalServiceDeliveryChannelsID: RentalServiceDeliveryChannel.Online,
      contractTypeID: 1 /* 1 = Short Term */

    }
    return model;
  }
  //#region
  log(a) {


  }
}
